(function () {
  function pdpScrollToThumbnailOnClick() {
    if (window.location.pathname.indexOf("/products/") === -1) return;

    const productColorSwatches = document.querySelectorAll(".product__color-swatch");
    
    if (productColorSwatches) {
      productColorSwatches.forEach(productColorSwatch => {
        productColorSwatch.addEventListener("click", function (e) {

          const activeProductThumbnail = document.querySelector(
            ".product-thumbnails__item-link.active",
          );
    
          if (activeProductThumbnail) {
            activeProductThumbnail.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        })
      });
    }
  }
  
  function productCardHoverSwatches() {
    /* ----------- Collections Page - Swatch Image Hover ---------- */
    const $productItemWithHoverSwatches = document.querySelectorAll(
      '.product-item--with-hover-swatches'
    );
  
    $productItemWithHoverSwatches.forEach(function ($productItem) {
      // Find .product-swatches-options__item--swatch and add hover event listener
      const $swatchOptions = $productItem.querySelectorAll(
        '.product-swatches-options__item--swatch'
      );
      const $productImageContainer = $productItem.querySelector(
        '.product-item__image--swatch-hover'
      );
      const $productImage = $productImageContainer.querySelector(
        '.image__img',
      );
      
      $swatchOptions.forEach(function ($swatchOption) {
        $swatchOption.addEventListener('mouseenter', function (e) {
          // Get the image source from the data attribute "data-swatch-hover-img"
          const imageSrc = $swatchOption.dataset.swatchHoverImg;
  
          if (!imageSrc) return;
          
          // change the source of .product-item__image--swatch-hover
          $productImage.src = imageSrc;
  
          // Add active class to the .product-item__image--swatch-hover to show the image
          $productImageContainer.classList.add('active');
        });
  
        $swatchOption.addEventListener('mouseleave', function (e) {
          $productImageContainer.classList.remove('active');
        });
      });
    });
  }

  function appSpuritPreOrderOpenCartEvents() {
    Spurit.globalOnLoad = function () {
      Spurit.global.atc.onBeforeEventPrevented((event, target) => {
        target.hasAttribute('data-pre-order-atc-button');
      });

      Spurit.global.atc.onBefore((event, target, lineItems, submitMode, next) => {
        next(Spurit.global.constants.ATC.SUBMIT_MODE_AJAX, lineItems);
      });

      Spurit.global.atc.onAfter((event, target, lineItems, submitMode) => {
        if (submitMode !== Spurit.global.constants.ATC.SUBMIT_MODE_AJAX) {
          return;
        }
        
        fetch('/cart.js', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then((response) => response.json())
          .then((data) => {
            console.log(data);
            const eventCartUpdated = new CustomEvent('cart:updated', {
              detail: {
                cart: data,
                app: 'spurit-preorder',
              },
            });
            document.dispatchEvent(eventCartUpdated);
          })
          .catch((error) => {
            console.error('Gift bag add error:', error);
          });
      });
    };
  }
  
  document.addEventListener('DOMContentLoaded', function (event) {
    // Init
    appSpuritPreOrderOpenCartEvents();
    productCardHoverSwatches();
    pdpScrollToThumbnailOnClick();
  });


  

 
     // Select all megamenu containers
  const megamenus = document.querySelectorAll('.meganav__nav');

  // Loop through each megamenu container
  megamenus.forEach(function(megamenu) {
    // Select the corresponding ul element within the megamenu
    const menuList = megamenu.querySelector('.meganav__list-parent');

    // Check if the menuList exists and has only two child li elements
    if (menuList && menuList.children.length === 2) {
       // Apply the inline styles to the menu list
       menuList.style.position = 'relative';
       menuList.style.right = '-125%';
      // Select all dividers within this megamenu
      const dividers = megamenu.querySelectorAll('.meganav__column-rule');

       // Check if there are more than one dividers
       if (dividers.length > 1) {
        // Remove all dividers except the first one
        dividers.forEach((divider, index) => {
          if (index === 0) {
            // Apply the inline style to the first divider
            divider.style.left = '49.5%';
          } else {
            // Remove all dividers except the first one
            divider.remove();
          }
        });
      }
    }
  });
 
})();



